import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import QRCode from "react-qr-code";
import Container from "@mui/material/Container";
import dayjs from "dayjs";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";

import { isMobile } from "react-device-detect";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import {StripedTableCell, StripedTableHeadCell, StripedTableRow} from "../../components/StripedTable";

import HeaderText from "../../components/HeaderText";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import { getActivity} from "../../services/ActivityService";
import { getQrBaseUrl } from "../../services/QrService";


const ActivityAttendQr = () => {
  // activity eid
  const { eid } = useParams();
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);
  const [_searchPerformed, setSearchPerformed] = useState(false);
  const [_qrUrl, setQrUrl] = useState("");

  const [_activity, setActivity] = useState({
    eid: "",
    name: "",
    period: "",
    last_name: "",
    first_name: "",
    locationName: "",
  });

  useEffect(() => {
    initContent();
  }, []);

  const initContent = () => {
    setShowProgress(true);

    const promises = [getActivity(_school, _jwt, eid), getQrBaseUrl(_school, _jwt)];
    Promise.all(promises).then((results) => {
      let result = results[0];
      console.log(result);

      setActivity(result.data.activity);
      setSearchPerformed(true);

      const baseUrl = results[1];
      setQrUrl(baseUrl + `/student/activity/attend/${eid}`)
      setShowProgress(false);
    });
  };


  const getQrCode = () => {
    if (isMobile) {
      return (
        <QRCode
          size={256}
          style={{ height: "auto", maxWidth: "80%", width: "80%" }}
          value={_qrUrl}
          viewBox={`0 0 256 256`}
        />
      );
    } else {
      return <QRCode size={512} value={_qrUrl} />;
    }
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Attendance QR Code" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Box sx={{ display: _searchPerformed ? "" : "none" }}>
          <HeaderText text={"for: " + _activity.name} />
          <Table size="small">
            <TableBody>
              <StripedTableRow>
                <StripedTableHeadCell>Location Name</StripedTableHeadCell>
                <StripedTableCell>{_activity.locationName}</StripedTableCell>
                <StripedTableHeadCell>Main Proctor</StripedTableHeadCell>
                <StripedTableCell>
                  {_activity.first_name} {_activity.last_name}
                </StripedTableCell>
              </StripedTableRow>
              <StripedTableRow>
                <StripedTableHeadCell>Date</StripedTableHeadCell>
                <StripedTableCell>
                ANY DATE
                </StripedTableCell>
              </StripedTableRow>
            </TableBody>
          </Table>
          <p style={{ textAlign: "center" }}>{getQrCode()}</p>
          <p><a href={_qrUrl}>Link</a></p>
        </Box>
      </Container>
    </>
  );
};

export default ActivityAttendQr;
